import SelectionOption from '../base/option/SelectionOption';
import Lang from '../global/Lang';
enum ShareType {
  FILE = 'FILE',
  DIRECTORY = 'DIRECTORY',
  MIX = 'MIX',
}

const ShareTypes: ShareType[] = Object.keys(ShareType).map(
  (k) => k as ShareType
);

const ShareTypeMap: { [key in keyof typeof ShareType]: SelectionOption } = {
  FILE: {
    name: Lang.t('matter.file'),
    value: 'FILE',
  },
  DIRECTORY: {
    name: Lang.t('matter.directory'),
    value: 'DIRECTORY',
  },
  MIX: {
    name: Lang.t('mixed'), // 需要在 LangZh 中添加 'mixed' 字段
    value: 'MIX',
  },
};

let ShareTypeList: SelectionOption[] = [];
ShareTypes.forEach((type: ShareType) => {
  ShareTypeList.push(ShareTypeMap[type]);
});

export { ShareType, ShareTypeMap, ShareTypeList };
